import React from 'react';
import { FileTextIcon, ZapIcon, HomeIcon, TimerIcon, ShieldCheckIcon, LockIcon, CreditCardIcon, BanknoteIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
import { HeroCarousel } from './HeroCarousel';
const TRUST_ITEMS = [{
  icon: FileTextIcon,
  title: '100% digital',
  detail: 'PDF + planificador imprimible'
}, {
  icon: ZapIcon,
  title: 'Acceso en 5 min',
  detail: 'Te llega al mail al instante'
}, {
  icon: HomeIcon,
  title: 'Sin gimnasio',
  detail: 'Sin equipo, desde tu casa'
}, {
  icon: TimerIcon,
  title: 'Rutinas cortas',
  detail: 'De 5, 15 y 30 minutos'
}];
const PAYMENT_ITEMS = [{
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: CreditCardIcon,
  label: 'Mercado Pago'
}, {
  icon: CreditCardIcon,
  label: 'Tarjeta'
}, {
  icon: BanknoteIcon,
  label: 'Transferencia'
}];
export function Hero() {
  return <section className="relative overflow-hidden bg-canvas" data-id="element-90" data-mp="381e25e7i07uk">
      <div aria-hidden="true" className="pointer-events-none absolute -top-24 left-1/2 h-64 w-[130%] -translate-x-1/2 rounded-[100%] bg-amber-soft opacity-70 blur-2xl" data-id="element-91" data-mp="3j8ix6zga0gup" />
      <div className="relative mx-auto max-w-page px-5 pb-10 pt-8 sm:pt-12" data-id="element-92" data-mp="3o6u5v6uu4lbc">
        <div className="mx-auto mb-5 flex w-fit items-center gap-2 rounded-full border border-line bg-paper px-3 py-1.5" data-id="element-93" data-mp="399jo5frlmj76">
          <span className="h-2 w-2 animate-pulse rounded-full bg-flame" data-id="element-94" data-mp="3e7l8s54oaqkr" />
          <span className="text-[11px] font-bold uppercase tracking-[0.14em] text-teal-600" data-id="element-95" data-mp="30h9d5w8vq9ov">
            Sistema digital · Precio de lanzamiento
          </span>
        </div>

        <h1 className="text-center font-display text-[42px] font-black leading-[0.98] tracking-tight text-night sm:text-[64px]" data-id="element-96" data-mp="2qkmrj58qbels">
          ¿Por qué vivís
          <span className="relative ml-2 inline-block" data-id="element-97" data-mp="2vgu25bc2lea2">
            <span className="relative z-10 italic text-flame" style={{
            fontSize: "62px"
          }} data-id="element-98" data-mp="2hk86m6zog1it">cansad@?</span>
            <span aria-hidden="true" className="absolute inset-x-0 bottom-1 z-0 h-3 -rotate-1 bg-amber/50 sm:h-4" data-id="element-99" data-mp="2ljz1alsbr1sm" />
          </span>
        </h1>

        <HeroCarousel data-id="element-100" data-mp="nat7pcgomml8" />

        <p className="mx-auto mt-6 max-w-xl text-center text-[16px] leading-relaxed text-teal-700 sm:text-lg" data-id="element-101" data-mp="na9yql90f8jc">
          El sistema para recuperar tu energía <strong className="font-extrabold text-night" data-id="element-102" data-mp="i9voqxnuloio">sin gimnasio</strong>,
          sin dietas extremas y sin depender de nadie que te siga todos los días.
        </p>

        <ul className="mt-8 grid grid-cols-2 gap-3" data-id="element-103" data-mp="1b0duk6fyi3zs">
          {TRUST_ITEMS.map(({
          icon: Icon,
          title,
          detail
        }) => <li key={title} className="flex flex-col gap-1.5 rounded-2xl border border-line bg-paper p-3.5 shadow-card" data-id="element-104" data-mp="112g6biy3k776">
              <Icon className="h-5 w-5 text-flame" aria-hidden="true" data-id="element-105" data-mp="x1w789tyqtie" />
              <span className="text-[13px] font-extrabold leading-tight text-night" data-id="element-106" data-mp="3lsp1j88sy9bs">{title}</span>
              <span className="text-[11.5px] leading-snug text-muted" data-id="element-107" data-mp="3hrdbx2pxho3l">{detail}</span>
            </li>)}
        </ul>

        <div className="mt-8" data-id="element-108" data-mp="1x9ul8c2qhfny">
          <CtaButton pulse data-id="element-109" data-mp="1xam4cnf59kxc" />
          <p className="mt-3 text-center text-[13px] font-semibold text-teal-700" data-id="element-110" data-mp="1x7869rdijxvp">
            +100 personas ya lo tienen
          </p>
        </div>

        <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 border-t border-line pt-5" data-id="element-111" data-mp="269r7y85kc4gd">
          {PAYMENT_ITEMS.map(({
          icon: Icon,
          label
        }) => <li key={label} className="flex items-center gap-1.5 text-[11.5px] font-semibold text-muted" data-id="element-112" data-mp="2g0c3tntuquvl">
              <Icon className="h-3.5 w-3.5 text-teal-600" aria-hidden="true" data-id="element-113" data-mp="2ky4352wttj9t" />
              {label}
            </li>)}
        </ul>
      </div>
    </section>;
}